<script lang="ts">
	import { ChartContext, ChartDimensions } from './ChartDimensions.svelte.js';

	import type { Snippet } from 'svelte';
	import { styleObject, type HTMLElementProps } from '@vpap_svelte/internal';
	import type { ChartContextType } from './ChartDimensions.svelte.js';

	let container: HTMLDivElement | undefined = $state(undefined);
	let chart: HTMLDivElement | undefined = $state(undefined);

	interface ContainerProps extends Omit<HTMLElementProps<HTMLDivElement>, 'children'> {
		children?: Snippet<[ChartContextType]>;
	}

	let { children, class: providedClass, style, ...attrs }: ContainerProps = $props();

	let boundaries = new ChartDimensions(
		() => container,
		() => chart,
	);
	let ctx = ChartContext.set(boundaries);
</script>

<div
	bind:this={container}
	class={['g-chart-wrapper', providedClass]}
	style={style ? styleObject(style) : undefined}
	{...attrs}
>
	<div bind:this={chart} class="g-chart">
		{#if children}
			{@render children(ctx)}
		{/if}
	</div>
</div>

<style>
	.g-chart-wrapper {
		height: 100%;
		width: 100%;
	}

	.g-chart-wrapper,
	.g-chart-wrapper :global(*) {
		box-sizing: border-box;
	}

	.g-chart {
		height: 100%;
		width: 100%;
		position: relative;
	}
</style>
